// CAROUSEL WITH autoplay
( function ($) {
    $(document).ready(function () {
    });
}(jQuery) );